import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { C, t } from '../constants/dashboardConstants';
import { useAuth } from '../../contexts/AuthContext';

const dismissKey = (id) => `castar_upgrade_banner_dismissed_${id}`;

/**
 * 대행(MANAGED) 계정에 정식 전환을 권하는 배너.
 *
 * 지원자 검토를 마친 직후처럼 '가치를 체감한 순간'에 한 번만 띄운다.
 * 닫으면 같은 맥락(id)에서는 다시 뜨지 않는다.
 */
export default function UpgradeAccountBanner({ id = 'default', message }) {
  const navigate = useNavigate();
  const { isManagedAccount } = useAuth();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(dismissKey(id)) === '1'; } catch { return false; }
  });

  if (!isManagedAccount || dismissed) return null;

  const close = () => {
    try { localStorage.setItem(dismissKey(id), '1'); } catch {}
    setDismissed(true);
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap',
      padding: '18px 20px', marginBottom: '16px',
      border: `1px solid ${C.g200}`, borderRadius: '14px', background: C.bg,
    }}>
      <div style={{ flex: 1, minWidth: '220px' }}>
        <div style={t('16px', 700, C.bk)}>이번 캐스팅은 잘 마치셨나요?</div>
        <div style={{ ...t('14px', 400, C.sub), marginTop: '4px', lineHeight: 1.5 }}>
          {message ?? '정식 계정으로 전환하면 공고를 직접 등록하고 보관함·일정까지 사용할 수 있습니다. 지금 계정과 데이터는 그대로 유지됩니다.'}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button
          onClick={close}
          style={{
            height: '44px', padding: '0 16px', borderRadius: '10px',
            border: 'none', background: 'none', cursor: 'pointer', ...t('14px', 500, C.sub),
          }}
        >
          나중에
        </button>
        <button
          onClick={() => navigate('/producer/settings?upgrade=1')}
          style={{
            height: '44px', padding: '0 20px', borderRadius: '10px',
            border: 'none', background: C.bk, cursor: 'pointer', ...t('14px', 600, C.white),
          }}
        >
          정식 계정으로 전환
        </button>
      </div>
    </div>
  );
}
